import { Observable } from 'rxjs';
import { AccountingRepository } from '../domain/accounting/repository';
import { Comprobante } from '../domain/accounting/model';
import HttpClient from '../utils/http-client';

export class AccountingRepositoryImplementation extends AccountingRepository {
  private httpClient: HttpClient;

  constructor(uid: string, cid: string | null) {
    super();
    this.httpClient = new HttpClient(uid, cid);
  }

  createComprobante(comprobante: Partial<Comprobante>): Observable<Comprobante> {
    return this.httpClient.post('/accounting/entries', comprobante);
  }

  getComprobante(id: number): Observable<any> {
    return this.httpClient.get(`/accounting/entries/${id}`);
  }

  getComprobantes(page: number, limit: number, filters?: any): Observable<any> {
    let query = `/accounting/vouchers?page=${page}&limit=${limit}`;
    if (filters) {
      if (filters.dateStart) query += `&dateStart=${filters.dateStart}`;
      if (filters.dateEnd) query += `&dateEnd=${filters.dateEnd}`;
      if (filters.documentType) query += `&documentType=${filters.documentType}`;
    }
    return this.httpClient.get(query);
  }

  getComprobantesById(id: number): Observable<any> {
    return this.httpClient.get(`/accounting/vouchers/${id}/lines`);
  }

  updateComprobante(id: number, comprobante: Partial<Comprobante>): Observable<Comprobante> {
    return this.httpClient.put(`/accounting/entries/${id}`, comprobante);
  }

  deleteComprobante(id: number): Observable<void> {
    return this.httpClient.delete(`/accounting/entries/${id}`);
  }

  getDocumentTypes(): Observable<any> {
    return this.httpClient.get('/accounting/document-types');
  }

  getClosingStatus(year: number): Observable<any> {
    return this.httpClient.get(`/accounting/closings/${year}`);
  }

  calculateClosing(data: any): Observable<any> {
    return this.httpClient.post('/accounting/closings/calculate', data);
  }

  approveClosing(data: any): Observable<any> {
    return this.httpClient.post('/accounting/closings/approve', data);
  }

  getCostingStatus(year: number, month: number): Observable<any> {
    return this.httpClient.get(`/accounting/costing/${year}/${month}`);
  }

  calculateCosting(data: any): Observable<any> {
    return this.httpClient.post('/accounting/costing/calculate', data);
  }

  approveCosting(data: any): Observable<any> {
    return this.httpClient.post('/accounting/costing/approve', data);
  }

  getTaxClosingStatus(year: number, month: number): Observable<any> {
    return this.httpClient.get(`/accounting/tax-closings/${year}/${month}`);
  }

  calculateTaxClosing(data: any): Observable<any> {
    return this.httpClient.post('/accounting/tax-closings/calculate', data);
  }

  approveTaxClosing(data: any): Observable<any> {
    return this.httpClient.post('/accounting/tax-closings/approve', data);
  }
}
